const basePath = "infrastructure-environmental-systems/";

export const datacenterTools = {
  id: 13,
  category: "Datacenter Tools & Operations",

  filters: {
    Brand: { type: "checkbox" },
    Type: { type: "checkbox" },
    Ports: { type: "checkbox" },
    Features: { type: "checkbox" },
    Speeds: { type: "checkbox" },
    Standards: { type: "checkbox" },
    Contents: { type: "checkbox" },
    Materials: { type: "checkbox" },
    "Load Rating": { type: "checkbox" },
    Capacity: { type: "checkbox" },
    Parameters: { type: "checkbox" },
  },

  subcategories: [
    {
      name: "KVM Consoles (Keyboard/Video/Mouse)",
      bestSeller: true,
      image: `${basePath}KVM_Consoles_(Keyboard_Video_Mouse).png`,
      details: {
        Brand: "Avocent/Raritan/APC",
        Type: "Over-IP KVM Switches",
        Ports: "4-64 server connections",
        Features: "IP-based, dual monitor support",
      },
      about: `
        <ul>
          <li>Consolidated console access enabling single keyboard/mouse to control multiple servers.</li>
          <li>Over-IP options allow remote access from anywhere.</li>
        </ul>
      `,
    },
    {
      name: "Crash Carts (Server Recovery Systems)",
      bestSeller: false,
      image: `${basePath}Crash_Carts_(Server_Recovery_Systems).png`,
      details: {
        Brand: "Avocent/Schneider",
        Type: "Mobile KVM/Console Cart",
        Features: "Monitor, keyboard, mouse, emergency access",
      },
      about: `
        <ul>
          <li>Mobile emergency access devices for out-of-band server management.</li>
          <li>Critical for recovery when network-based management is unavailable.</li>
        </ul>
      `,
    },
    {
      name: "Network Toolkits & Testers",
      bestSeller: false,
      image: `${basePath}Network_Toolkits_&_Testers.png`,
      details: {
        Brand: "Fluke/Ideal/Greenlee",
        Type: "Cable Tester / Network Multimeter",
        Features: "Continuity, tone testing, PoE detection",
      },
      about: `
        <ul>
          <li>Handheld testing tools for network cable troubleshooting and verification.</li>
          <li>Essential diagnostic instruments for field technicians.</li>
        </ul>
      `,
    },
    {
      name: "Label Printers (Thermal/Inkjet)",
      bestSeller: true,
      image: `${basePath}Label_Printers_(Thermal_Inkjet).png`,
      details: {
        Brand: "Brother/Zebra/Epson",
        Type: "Label Printer",
        Speeds: "50-300mm/s",
        Features: "Ethernet, mobile-friendly",
      },
      about: `
        <ul>
          <li>Dedicated label printers for network cable, port, and asset tagging.</li>
          <li>Enable consistent documentation and inventory tracking.</li>
        </ul>
      `,
    },
    {
      name: "Cable Testers & Optical Power Meters",
      bestSeller: false,
      image: `${basePath}cable-tester.png`,
      details: {
        Brand: "Fluke/EXFO/Ideal",
        Type: "Optical Power Meter / Light Source",
        Standards: "SM/MM Fiber compatible",
        Features: "dBm measurement, wavelength specific",
      },
      about: `
        <ul>
          <li>Precision instruments for measuring fiber optic cable loss and signal strength.</li>
          <li>Essential for fiber installation and maintenance verification.</li>
        </ul>
      `,
    },
    {
      name: "Fiber Cleaning Kits",
      bestSeller: false,
      image: `${basePath}Fiber_Cleaning_Kits.png`,
      details: {
        Brand: "Panduit/Corning/Thorlabs",
        Type: "Fiber Connector Cleaner",
        Contents: "Wipes, cleaners, inspection scope",
        Features: "IPA-free options available",
      },
      about: `
        <ul>
          <li>Professional cleaning kits for maintaining optical fiber connector quality.</li>
          <li>Critical for preventing signal loss and equipment damage.</li>
        </ul>
      `,
    },
    {
      name: "Rack Lighting & Illumination",
      bestSeller: false,
      image: `${basePath}Rack_Lighting_&_Illumination.png`,
      details: {
        Brand: "APC/Rittal/Eaton",
        Type: "LED Rack Mount Light",
        Features: "Dimmable, power-efficient, motion sensor options",
      },
      about: `
        <ul>
          <li>LED lighting mounted inside racks for equipment inspection and maintenance.</li>
          <li>Improve visibility and reduce eye strain during troubleshooting.</li>
        </ul>
      `,
    },
    {
      name: "Airflow Panels & Blanking Panels",
      bestSeller: true,
      image: `${basePath}Airflow_Panels_&_Blanking_Panels.png`,
      details: {
        Brand: "APC/Rittal/Eaton",
        Type: "Hot/Cold Aisle Containment",
        Materials: "Polycarbonate / Metal",
        Features: "Removable, interlocking",
      },
      about: `
        <ul>
          <li>Panels and baffles for hot-aisle/cold-aisle containment strategies.</li>
          <li>Improve cooling efficiency by preventing hot/cold air mixing.</li>
        </ul>
      `,
    },
    {
      name: "Raised Flooring Tiles",
      bestSeller: true,
      image: `${basePath}Raised_Flooring_Tiles.png`,
      details: {
        Brand: "Raised Access / Eaton / Schneider",
        Type: "Aluminum/Steel Raised Floor Tile",
        "Load Rating": "500-4000+ lbs per tile",
        Features: "Static-dissipative, perforated or solid",
      },
      about: `
        <ul>
          <li>Modular raised flooring systems for cable/cooling distribution beneath data center floors.</li>
          <li>Support equipment weight and enable air distribution for CRAC/CRAH systems.</li>
        </ul>
      `,
    },
    {
      name: "UPS Monitoring Software",
      bestSeller: false,
      image: `${basePath}UPS_Monitoring_Software.png`,
      details: {
        Brand: "PowerChute / PowerShield / Eaton EMS",
        Type: "UPS Management Platform",
        Features: "Remote monitoring, automation, scalability",
      },
      about: `
        <ul>
          <li>Centralized software for monitoring and managing multiple UPS units across facilities.</li>
          <li>Enable scheduled shutdowns, event notifications, and energy reporting.</li>
        </ul>
      `,
    },
    {
      name: "Asset Management Tags",
      bestSeller: true,
      image: `${basePath}Asset_Management_Tags.png`,
      details: {
        Brand: "Brady/Panduit/Legrand",
        Type: "QR/Barcode Asset Tags",
        Materials: "Polyester/Aluminum",
        Features: "Durable, UV/weather resistant",
      },
      about: `
        <ul>
          <li>Identification tags for tracking infrastructure assets and equipment lifecycle.</li>
          <li>Enable automated inventory management and compliance reporting.</li>
        </ul>
      `,
    },
    {
      name: "Anti-Static Mats & ESD Protection",
      bestSeller: false,
      image: `${basePath}Anti-Static_Mats_&_ESD_Protection.jpg`,
      details: {
        Brand: "3M/Desco/Transforming Technologies",
        Type: "ESD Flooring / Wrist Straps",
        Standards: "ESD S4.1 / IEC 61340-5-1",
        Features: "Conductive, grounded",
      },
      about: `
        <ul>
          <li>Electrostatic discharge protection mats and grounding equipment for component handling.</li>
          <li>Prevent accidental damage during maintenance and equipment installation.</li>
        </ul>
      `,
    },
    {
      name: "Lifting Tools & Hoists",
      bestSeller: false,
      image: `${basePath}Lifting_Tools_&_Hoists.png`,
      details: {
        Brand: "Duff-Norton/Columbus McKinnon",
        Type: "Portable Hoist / Lifting Sling",
        Capacity: "500-5000 lbs options",
        Features: "Manual, motorized, safety-rated",
      },
      about: `
        <ul>
          <li>Mechanical lifting equipment for safely moving heavy infrastructure and equipment.</li>
          <li>Prevent injury and equipment damage during installation and maintenance.</li>
        </ul>
      `,
    },
    {
      name: "DCIM Platforms (Data Center Infrastructure Management)",
      bestSeller: false,
      image: `${basePath}DCIM_Platforms_(Data_Center_Infrastructure_Management).png`,
      details: {
        Brand: "Schneider/Vertiv/Nlyte",
        Type: "Facility Management Software",
        Features: "Asset tracking, power/cooling analytics, capacity planning",
      },
      about: `
        <ul>
          <li>Comprehensive software platforms for data center infrastructure monitoring and optimization.</li>
          <li>Provide real-time visibility into power usage, cooling, capacity, and asset lifecycle.</li>
        </ul>
      `,
    },
    {
      name: "Barcode Scanners & Inventory Systems",
      bestSeller: false,
      image: `${basePath}barcode-scanner.png`,
      details: {
        Brand: "Zebra/Honeywell/Datalogic",
        Type: "Handheld / Fixed Barcode Scanner",
        Standards: "1D/2D codes, mobile integration",
        Features: "Wireless, battery-powered",
      },
      about: `
        <ul>
          <li>Scanning tools for inventory tracking, asset management, and order fulfillment.</li>
          <li>Enable efficient data entry and real-time visibility into equipment deployment.</li>
        </ul>
      `,
    },
    {
      name: "Environmental Monitoring Systems (Remote)",
      bestSeller: true,
      image: `${basePath}Environmental_Monitoring_Systems_(Remote).png`,
      details: {
        Brand: "Akcp/Geist/Vertiv",
        Type: "Remote Monitoring Probes",
        Parameters: "Temperature, Humidity, Water Leak, Air Quality",
        Features: "IP-based, cloud integration",
      },
      about: `
        <ul>
          <li>Distributed sensor networks for continuous facility environmental monitoring.</li>
          <li>Provide alerts for out-of-range conditions; integrate with DCIM and alerting systems.</li>
        </ul>
      `,
    },
  ],
};
